<script setup lang="ts">
  import { RouterView } from 'vue-router'
</script>

<template>
  <!-- Error pages are full-page experiences with their own navigation -->
  <RouterView />
</template>
